import React, {useEffect} from 'react';
import {Container} from "react-bootstrap";

const PlayqLoginComponent =
    ({...rest}) => {
        const clientId = "kr.playq";
        const rediretUrl = "https://vw.boxtree.co.kr/apple/callback";
        const responseType = 'code id_token';
        const scope="email name";
        const responseMode="fragment";

        useEffect(() => {
            const url = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${rediretUrl}&nonce=NONCE&response_type=${responseType}&scope=&response_mode=${responseMode}`;
            window.location.href=url;
        },[]);
        return (
            <Container>
            <div className="text-center text-secondary m-5">애플 로그인 페이지 이동중..</div>
            </Container>
        );
    }

export default PlayqLoginComponent;
